export const validateNumber = (input) =>{
    if(input == "") return  true;
    return /^\d+$/.test(input);
}